const sectors = {
  general: {
    title: 'Tudo',
  },
  health: {
    title: 'Saúde pública',
  },
  economy: {
    title: 'Economia',
  },
  management: {
    title: 'Ferramentas',
  },
}
export default sectors

export function getSectorsForDomain(domain: string | null): string[] | null {
  // const sectorFilter = 'sed.prixapp.com.br' === domain ? ['general', 'education', 'management'] : null
  const sectorFilter = ['general', 'health', 'economy', 'management']
  return sectorFilter
}
